import { VEHICLE_ROUTES } from '../routes-typed'

const REGISTERED_VEHICLE_DETAIL =
  /\/(?:list|blocks)\/vehicle\/[^/]+|\/vehicle\/[^/]+\/(?:vehicleDailyActivity|vehicleWeeklyActivity|vehicleCalendar)\b/

export function pathForSelectedVehicle(
  pathname: string,
  companyId: string,
  vehicleId: string | number,
): string {
  const id = String(vehicleId)
  const numericId = Number(vehicleId)

  if (REGISTERED_VEHICLE_DETAIL.test(pathname)) {
    return pathname.replace(/(\/vehicle\/)[^/]+/, `$1${id}`)
  }

  if (pathname.includes('/vehicleModule/blocks')) {
    return VEHICLE_ROUTES.blocksDetail.buildPath({
      companyId,
      vehicleId: numericId,
    })
  }

  return VEHICLE_ROUTES.basicData.buildPath({
    companyId,
    vehicleId: numericId,
  })
}

export function pathForVehicleGroup(
  pathname: string,
  companyId: string,
): string {
  if (pathname.includes('/vehicleModule/blocks')) {
    return VEHICLE_ROUTES.blocksList.buildPath({ companyId })
  }
  return VEHICLE_ROUTES.list.buildPath({ companyId })
}
